import { createApiRef } from "@backstage/core-plugin-api";

import {
  IoArgoprojWorkflowV1alpha1WorkflowList,
  IoArgoprojWorkflowV1alpha1WorkflowTemplateList,
} from "./generated/api";

export { ArgoWorkflows } from "./ArgoWorkflows";

/** Raw workflow object from the K8s API (untyped — generated types don't cover single workflow) */
export type ArgoWorkflow = {
  metadata: { name?: string; namespace?: string; creationTimestamp?: string };
  spec: {
    arguments?: { parameters?: Array<{ name: string; value?: string }> };
    entrypoint?: string;
  };
  status?: {
    phase?: string;
    message?: string;
    startedAt?: string;
    finishedAt?: string;
    progress?: string;
    nodes?: Record<
      string,
      {
        id: string;
        name: string;
        displayName: string;
        type: string;
        phase: string;
        message?: string;
        startedAt?: string;
        finishedAt?: string;
        inputs?: { parameters?: Array<{ name: string; value?: string }> };
        outputs?: {
          parameters?: Array<{ name: string; value?: string }>;
          exitCode?: string;
          result?: string;
          artifacts?: Array<{ name: string; s3?: { key?: string } }>;
        };
      }
    >;
  };
};

export const argoWorkflowsApiRef = createApiRef<ArgoWorkflowsApi>({
  id: "plugin.argoworkflows",
});
export interface ArgoWorkflowsApi {
  getWorkflows(
    clusterName: string | undefined,
    namespace: string | undefined,
    labels: string | undefined
  ): Promise<IoArgoprojWorkflowV1alpha1WorkflowList>;
  getWorkflowTemplates(
    clusterName: string | undefined,
    namespace: string,
    labels: string | undefined
  ): Promise<IoArgoprojWorkflowV1alpha1WorkflowTemplateList>;
  getWorkflow(
    clusterName: string | undefined,
    namespace: string,
    name: string
  ): Promise<ArgoWorkflow>;
  getPodLogs(
    clusterName: string | undefined,
    namespace: string,
    podName: string,
    container?: string
  ): Promise<string>;
}
